const url = "https://hdmovietoday.xyz";
// const url = "http://localhost:5001";
module.exports = url;
